export default {
  data() {
    return {
      // url: "https://assessment.simplifymycareer.com/*", //staging
      url: "https://assessment.hire3x.com/*", //production
    };
  },
};
